import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SSOService from 'utils/network/sso/sso.service';
import { useNavigate } from 'react-router-dom';
import { STATUS_SUCCESS, MESSAGE_ERROR_INTERNAL_SERVER } from 'utils/constants';
import { useNotif } from 'context/NotificationContext';

const SSOCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { notification, setNotification } = useNotif();

  const handleSSOCallback = async () => {
    if (!sessionStorage.length) {
      SSOService.authSso();
    }
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const state = params.get('state');
    const stateSession = sessionStorage.getItem('state');

    try {
      if (stateSession === state) {
        const responeToken = await SSOService.getToken(code);

        if (responeToken.status !== STATUS_SUCCESS) {
          setNotification({
            ...notification,
            show: true,
            title: responeToken.data.message,
            error: true
          });

          return;
        }

        const responeInfo = await SSOService.getUserInfo(
          responeToken.data.token_type,
          responeToken.data.access_token
        );

        if (responeInfo.status !== STATUS_SUCCESS) {
          setNotification({
            ...notification,
            show: true,
            title: responeInfo.data.message,
            error: true
          });

          return;
        }

        const responeKeyCloack = await SSOService.getKeyCloak(
          responeToken.data.token_type,
          responeToken.data.access_token
        );

        if (responeKeyCloack.status !== STATUS_SUCCESS) {
          setNotification({
            ...notification,
            show: true,
            title: responeKeyCloack.data.message,
            error: true
          });

          return;
        }

        localStorage.setItem('tokenSso', responeToken.data.access_token);
        localStorage.setItem('token', responeKeyCloack.data.data.access_token);
        localStorage.setItem(
          'refresh_token',
          responeKeyCloack.data.data.refresh_token
        );
        localStorage.setItem('is_login', true);
        localStorage.setItem('md_email', responeInfo.data.md5_email);
        sessionStorage.removeItem('state');
        return navigate('/', { replace: true });
      }
    } catch (error) {
      setNotification({
        ...notification,
        show: true,
        title: MESSAGE_ERROR_INTERNAL_SERVER,
        error: true
      });
    }
  };

  useEffect(() => {
    handleSSOCallback();
  }, [location]);
};

export default SSOCallback;
